"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var csx = require("../base/csx");
var React = require("react");
var styles = require("../styles/styles");
var ErrorMessage = /** @class */ (function (_super) {
    __extends(ErrorMessage, _super);
    function ErrorMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorMessage.prototype.render = function () {
        var style = {
            padding: '20px',
            fontSize: '1.3rem',
            fontWeight: 'bold',
            color: styles.errorColor,
        };
        return React.createElement("div", { style: csx.extend(csx.flex, csx.centerCenter, style) }, this.props.text);
    };
    return ErrorMessage;
}(React.PureComponent));
exports.ErrorMessage = ErrorMessage;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/tabs/errorMessage.js
 ** module id = 454
 ** module chunks = 0
 **/